import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

const Teleexpertise = Lazy(() => import("@shared/features/teleexpertise/pages/teleexpertise"), "Teleexpertise");
const TeleexpertiseList = Lazy(() => import("@shared/features/teleexpertise/pages/teleexpertise-list"), "TeleexpertiseList");

export const getTeleexpertiseRoutes = (): RouteObject[] => {
  return [
    {
      path: "teleexpertises",
      children: [
        { index: true, element: <TeleexpertiseList /> },
        { path: ":id", element: <Teleexpertise /> },
      ],
    },
  ];
};
